import { EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Constants } from '../../common/constants';
import { DataService } from '../../services/api/data.service';
import { BroadcastService } from '../../services/broadcast.service';
import { SessionService } from '../../services/session/session.service';
var ChangeTemporaryPasswordDialogComponent = /** @class */ (function () {
    function ChangeTemporaryPasswordDialogComponent(dataService, broadcaster, sessionService) {
        this.dataService = dataService;
        this.broadcaster = broadcaster;
        this.sessionService = sessionService;
        this.isVisibleValue = false;
        this.isVisibleChange = new EventEmitter();
        this.notChangeTempPassword = new EventEmitter();
        this.temporaryPasswordChanged = new EventEmitter();
        this.isChangePassworSuccessDialog = false;
        this.showPassword = false;
        this.ngUnsubscribe = new Subject();
    }
    Object.defineProperty(ChangeTemporaryPasswordDialogComponent.prototype, "isVisible", {
        get: function () {
            return this.isVisibleValue;
        },
        set: function (value) {
            if (this.isVisibleValue !== value) {
                this.isVisibleValue = value;
                this.isVisibleChange.emit(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    ChangeTemporaryPasswordDialogComponent.prototype.keydown = function (e) {
        if (e.keyCode !== 13) {
            return;
        }
        this.onChangePassword();
    };
    ChangeTemporaryPasswordDialogComponent.prototype.onChangePasswordDialogAction = function (action) {
        if (action === 'ChangePassword') {
            this.onChangePassword();
        }
        else {
            this.isVisible = false;
            this.notChangeTempPassword.emit();
        }
    };
    ChangeTemporaryPasswordDialogComponent.prototype.onChangePassSuccessNotificationAction = function (action) {
        this.temporaryPasswordChanged.emit(this.newPass);
        this.currentPassword = '';
        this.newPass = '';
        this.isVisible = false;
    };
    ChangeTemporaryPasswordDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.broadcaster
            .on(Constants.ACCOUNT_CHANGE_TEMPORARY_PASSWORD)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (temporaryPassword) {
            _this.currentPassword = temporaryPassword;
        });
    };
    ChangeTemporaryPasswordDialogComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    ChangeTemporaryPasswordDialogComponent.prototype.onChangePassword = function () {
        var _this = this;
        var request = { CurrentPassword: this.currentPassword, NewPassword: this.newPass };
        this.dataService.Auth_ChangePassword(request).subscribe(function () {
            _this.isChangePassworSuccessDialog = true;
        }, function (error) {
            _this.isVisible = true;
        });
    };
    return ChangeTemporaryPasswordDialogComponent;
}());
export { ChangeTemporaryPasswordDialogComponent };
